import { getConversationById } from '@app/helpers'
import { Message } from '@app/models'

import { ChatState, ExistMessageReceivedPayload } from '../types'

export const onExistMessageReceived = (
  state: ChatState,
  payload: ExistMessageReceivedPayload
): ChatState => {
  const { conversationId, uuid, creationDate, updateDate } = payload

  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation || !uuid) {
    return state
  }

  const messageIndex = conversation.messages.findIndex(
    (item) => item.uuid === uuid
  )
  if (messageIndex === -1) {
    return state
  }

  const message: Message = {
    ...conversation.messages[messageIndex],
    creationDate,
    updateDate,
    sendStatus: 'Sent',
  }

  const messages: Message[] = [
    ...conversation.messages.slice(0, messageIndex),
    message,
    ...conversation.messages.slice(messageIndex + 1),
  ]

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...conversation,
        messages,
        updateDate,
      },
    },
  }
}
